import { Text } from 'blaze-ui/Text/Text'
import { BlogIntegrationSelect } from 'components/ExternalIntegrationSelect/BlogIntegrationSelect'
import { AlertTriangle } from 'blaze-ui/icons'
import cx from 'classnames'
import Styles from '../../../BlogMetadata.module.scss'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

interface BlogMetadataHeaderProps {
  blogIntegrationsCount: number
}

export const BlogMetadataHeader: React.FC<BlogMetadataHeaderProps> = ({ blogIntegrationsCount }) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()

  return (
    <>
      <div className={Styles.descriptionContainer}>
        {isSystemRedesignEnabled && (
          <Text variant="secondary" color="var(--dark-90)">
            Configure Blog Metadata
          </Text>
        )}
        <Text
          variant={isSystemRedesignEnabled ? 'metadata' : 'secondary'}
          color={isSystemRedesignEnabled ? 'var(--dark-40)' : 'var(--dark-80)'}
        >
          Configuring metadata helps improve your blog post's SEO, visibility, and shareability across search engines
          and social media platforms.
        </Text>
      </div>
      <div className={Styles.content}>
        <div
          className={cx(Styles.integrationsSelect, {
            [Styles.integrationsSelectNoIntegration]: blogIntegrationsCount === 0,
          })}
        >
          <BlogIntegrationSelect
            buttonVariant="secondary"
            renderPlatformIcon
            size={isSystemRedesignEnabled ? 'md' : 'sm'}
          />
          {blogIntegrationsCount === 0 && <AlertTriangle color="var(--red-70)" />}
        </div>
      </div>
    </>
  )
}
